/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Tiktok = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/TikTok"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#0E0E0E"
        d="M16.983 5.134A4.82 4.82 0 0 1 15.838 2h-.896a4.77 4.77 0 0 0 2.041 3.134m-8.292 6.771c-1.552 0-2.815 1.295-2.815 2.888 0 1.11.616 2.076 1.512 2.559a2.9 2.9 0 0 1-.534-1.686c0-1.593 1.263-2.888 2.815-2.888.29 0 .57.05.833.134v-3.51a6 6 0 0 0-.833-.06c-.05 0-.095.004-.145.004v2.693a2.8 2.8 0 0 0-.833-.134"
      />
      <path
        fill="#0E0E0E"
        d="M19.522 6.676v2.67a7.84 7.84 0 0 1-4.662-1.537v6.989c0 3.487-2.765 6.329-6.169 6.329a6.04 6.04 0 0 1-3.534-1.147C6.284 21.22 7.89 22 9.669 22c3.4 0 6.17-2.837 6.17-6.33V8.683A7.84 7.84 0 0 0 20.5 10.22V6.783q-.51-.002-.978-.107"
      />
      <path
        fill="#0E0E0E"
        d="M14.86 14.798v-6.99a7.84 7.84 0 0 0 4.662 1.538v-2.67a4.64 4.64 0 0 1-2.539-1.542A4.8 4.8 0 0 1 14.937 2h-2.453l-.004 13.778c-.055 1.542-1.295 2.781-2.81 2.781-.942 0-1.77-.478-2.287-1.202a2.91 2.91 0 0 1-1.511-2.56c0-1.592 1.262-2.887 2.815-2.887.29 0 .57.05.833.134V9.351c-3.331.074-6.02 2.879-6.02 6.32a6.4 6.4 0 0 0 1.657 4.309 6.04 6.04 0 0 0 3.534 1.147c3.4 0 6.17-2.842 6.17-6.33"
      />
    </g>
  </svg>
);

export const TiktokIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'tiktok-icon'}
      icon={Tiktok}
      {...props}
      size={size}
    />
  );
};
